export var COMPONENT_TYPES = {
  HIDE: 'hide',
  PASS_THROUGH: 'passThrough',
  TOOLTIP: 'tooltip'
};
export var FALLBACK_TYPES = {
  NONE: 'NONE',
  ERROR: 'ERROR'
};
export var ROUTE_TYPES = {
  REDIRECT: 'redirect',
  ERROR: 'error'
};
export var SET_PERMISSIONS = 'SET_PERMISSIONS';
export var SET_PERMISSIONS_ERROR = 'SET_PERMISSIONS_ERROR';
export var REDUCER_NAME = 'permissions';